module.exports = __webpack_public_path__ + "img/push-puller-1.5e2acfa8.svg";